// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3fce6841","239":"f2dfeb5a","455":"ea910598"}[chunkId] + ".chunk.js";
};